<template>
  <div class="tags-page pr-40">
    <div class="tags-page__header">
      <router-link
        :to="{
          name: this.$route.name == 'set-notification' ? 'forms-list' : 'study-activities'
        }"
        class="d-block tags-page__back-to-activities fs-14"
      >
        <img src="static/img/activity-configurator/arrow-left.svg" alt /> Back
      </router-link>
      <NotificationHeader description="View and manage notifications for your activity" :activityName="activityName" @addNotification="addNotification">
        <div id="datatable_filter" slot="searchNotification" class="th-notification_search col-md-7 p-0">
          <input type="search" class="form-control form-control-sm" placeholder="Search" aria-controls="datatable" v-model="notificationSearch" />
        </div>
      </NotificationHeader>
    </div>
    <NotificationTable :count="allNotifications && allNotifications.length" :notifications="currentNotificationList" @onEditNotification="onEditNotification" @deleteNotification="deleteNotification" @onSortColumn="onSortColumn" @prevPage="prevPage" @nextPage="nextPage" :pagination="pagination" />
  </div>
</template>

<script>
import slice from "lodash/slice";
import ceil from "lodash/ceil";
import NotificationTable from "./notification-table";
import NotificationHeader from "./header";
export default {
  props: {
    activityName: {
      type: String
    },
    allNotifications: {
      type: Array
    }
  },
  data() {
    return {
      currentPageNo: 1,
      notificationSearch: "",
      sortNotification: [],
      pagination: {
        current: 1,
        total: 1
      },
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        sortOrder: "ASC",
        sortValue: "name"
      },
      sortMap: {
        stepName: "ASC",
        firstName: "ASC",
        stepType: null,
        triggeringResponse: null,
        actions: null
      },
      selectedForms: [],
      currentNotificationList: [],
      scheduleFormOptions: []
    };
  },
  components: {
    NotificationTable,
    NotificationHeader
  },
  mounted() {},
  watch: {
    allNotifications: function(newVal) {
      if (newVal) {
        this.showActivities();
      }
    },
    filterNotifications(newVal) {
      if (newVal) {
        this.showActivities();
      }
    }
  },
  computed: {
    filterNotifications() {
      if (this.notificationSearch) {
        const searchResult =
          this.allNotifications &&
          this.allNotifications.filter(item => {
            return this.notificationSearch
              .toLowerCase()
              .split(" ")
              .every(v => item.stepName && item.stepName.toLowerCase().includes(v));
          });
        return searchResult.length ? searchResult : this.allNotifications;
      } else {
        return this.allNotifications;
      }
    }
  },
  methods: {
    sortNotificationData(columnName, order) {
      this.sortMap[columnName] = order;
      const columnType = "string";
      if (columnType == "string") {
        if (columnName === "firstName") {
          this.sortByString("stepName", order);
        } else {
          this.sortByString(columnName, order);
        }
      }
      this.showActivities(10);
      this.$forceUpdate();
    },
    sortByString(columnName, order) {
      if (order == "ASC") {
        this.filterNotifications.sort((a, b) => {
          const nameA = a[columnName] && a[columnName].toLowerCase();

          const nameB = b[columnName] && b[columnName].toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
      } else {
        this.filterNotifications.sort((a, b) => {
          const nameA = a[columnName] && a[columnName].toLowerCase();

          const nameB = b[columnName] && b[columnName].toLowerCase();
          if (nameA < nameB) {
            return 1;
          }
          if (nameA > nameB) {
            return -1;
          }
          return 0;
        });
      }
    },
    prevPage() {
      if (this.pagination.current <= this.pagination.total) {
        this.pagination.current -= 1;
        this.currentNotificationList = this.selectedForms[this.pagination.current - 1];
      }
    },
    nextPage() {
      if (this.pagination.current < this.pagination.total) {
        this.currentNotificationList = this.selectedForms[this.pagination.current];
        this.pagination.current += 1;
      }
    },
    showActivities() {
      this.pagination.total = ceil(this.filterNotifications.length / this.queryParams.pageSize) === 0 ? 1 : ceil(this.filterNotifications.length / this.queryParams.pageSize);
      this.selectedForms = [];
      let start = 0;
      let end = this.queryParams.pageSize;
      for (let index = 0; index < this.pagination.total; index++) {
        this.selectedForms.push(slice(this.filterNotifications, start, end));
        start += this.queryParams.pageSize;
        end += this.queryParams.pageSize;
      }
      if (!this.scheduleFormOptions || !this.scheduleFormOptions.length) {
        for (let index = 1; index <= this.pagination.total; index++) {
          this.scheduleFormOptions.push({
            value: index * 10,
            text: `Show ${index * 10} items`
          });
        }
      }
      this.pagination.current = 1;
      const allActivities = this.selectedForms[this.pagination.current - 1];
      this.currentNotificationList = allActivities;
    },
    addNotification() {
      this.$emit("onAddNotification");
    },
    deleteNotification(notification) {
      this.$emit("deleteNotification", notification);
    },
    onSortColumn(eventData) {
      const { name, sort } = eventData.column;
      this.sortNotificationData(name, eventData.order || sort);
    },
    onEditNotification(event) {
      this.$emit("onEditNotification", event);
    }
  }
};
</script>

<style lang="scss" scoped>
.th-notification_search input {
  width: 96%;
  height: 36px;
  background-image: url(/static/img/activity-configurator/activity-library-search.svg) !important;
  background-position: right 2% top 80% !important;
  background-repeat: no-repeat;
  background-size: 26px 27px;
  border-radius: 0.2rem;
  border: none;
}
.tableBg {
  background-color: #ffffff !important;
  padding: 24px 20px 14px 20px !important;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
}
.form-name {
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #1e8fe1;
}
.create-edit-packet-page {
  &__order-table {
    tr {
      height: 41px;
      border-bottom: 1px solid #d3dfe4;
    }
  }

  &__add-forms-table {
    tr {
      height: 41px;
      border-bottom: 1px solid #d3dfe4;
    }

    input[type="checkbox"] {
      // display: none;
      height: 21px;
      width: 21px;
    }
  }

  &__order-table,
  &__add-forms-table {
    th {
      font-family: "RobotoRegular";
      font-size: 11px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 2.18;
      letter-spacing: normal;
      color: #b0bac9;
    }

    td {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 16px;
      letter-spacing: normal;
      color: #000000;
    }

    .activity_type {
      font-size: 12px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 2;
      letter-spacing: normal;
      color: #000000;
    }
  }
}
</style>
